// Modo Carreira — Português (Brasil).
/* eslint-disable no-template-curly-in-string */
const resources = {
    tiers: { facil: 'Fácil', medio: 'Médio', dificil: 'Difícil', imposible: 'Impossível' },

    common: {
        continue: 'Continuar',
        close: 'Fechar',
        cancel: 'Cancelar',
        save: 'Salvar',
        confirm: 'Confirmar',
        back: 'Voltar',
        yes: 'Sim',
        no: 'Não',
        vs: 'vs',
        away: '@',
        free: 'Livre',
        go: 'Ir',
    },

    maintenance: {
        title: 'CARREIRA DE ELITE EM MANUTENÇÃO',
        line1: 'Estamos melhorando o jogo com várias novidades.',
        line2: 'Em breve vocês vão poder jogar de novo! 🙌',
        thanks: 'Obrigado pela paciência 💛',
        adminBanner: '🔧 Carreira de Elite EM MANUTENÇÃO — só admins podem jogar. (Altere isso no painel de admin.)',
    },

    noauth: {
        title: '⚽ CARREIRA DE ELITE',
        text: 'Você precisa estar logado para jogar Carreira de Elite. Assim salvamos seu progresso e suas conquistas.',
        login: 'Entrar',
        backHome: 'Voltar ao início',
    },

    welcome: {
        emoji: '⚽💛',
        title: 'Bem-vindo à Carreira de Elite!',
        text1: 'Este jogo é um pouco diferente dos outros: você não escolhe um time pronto, você começa com um jogador criado por você mesmo, do zero.',
        text2: 'Você vai ter que conquistar cada convocação, cada título e cada transferência para um clube de elite com suas próprias decisões e resultados.',
        text3: 'Fizemos isso com muito amor. Se você gostar, ajuda demais se compartilhar sua carreira nas redes sociais ou com os amigos. 💛',
        button: 'Vamos jogar!',
    },

    tour: {
        skip: 'Pular',
        next: 'Próximo',
        prev: 'Voltar',
        finish: 'Entendi!',
        stepOf: 'Passo {{current}} de {{total}}',
        steps: {
            tables: {
                title: '📊 Tabelas',
                text: 'Aqui você vê a tabela da sua liga e das copas em que participa. Elas se atualizam partida a partida.',
            },
            achievements: {
                title: '🏆 Conquistas',
                text: 'Toque aqui para ver todas as conquistas que você pode ganhar na sua carreira, e seu progresso em cada uma.',
            },
            stats: {
                title: '⚡ Atributos',
                text: 'Gerencie os atributos do seu jogador aqui. Conforme você ganha pontos, pode distribuí-los como quiser.',
            },
            seleccion: {
                title: '🌍 Seleção',
                text: 'Se o seu nível for alto o suficiente, você será convocado para a seleção do seu país. Acompanhe as eliminatórias e a Copa do Mundo aqui.',
            },
            tactics: {
                title: '📋 Táticas',
                text: 'Escolha a tática do seu time antes de cada partida para tirar o máximo proveito do seu jogador.',
            },
            simulate: {
                title: '▶️ Simular',
                text: 'Use estes botões para avançar partida a partida. Você também pode ativar o modo automático para simular várias seguidas.',
            },
        },
    },

    loading: {
        text: 'Carregando Carreira de Elite...',
    },

    creator: {
        title: '⚽ CARREIRA DE ELITE',
        subtitle: 'Crie seu jogador e comece sua história do zero.',
        tabDatos: '📋 Dados',
        tabCabeza: '🧑 Cabeça',
        tabCuerpo: '👕 Corpo',
        defaultPlayerName: 'Seu jogador',
        nameLabel: 'Nome',
        namePlaceholder: 'Nome do seu jogador',
        nationalityLabel: 'Nacionalidade',
        nationalityPlaceholder: 'Escolha sua nacionalidade',
        positionLabel: 'Posição',
        physicalLabel: 'Físico',
        heightLabel: 'Altura',
        weightLabel: 'Peso',
        attributesLabel: 'Atributos · pontos para distribuir',
        skinLabel: 'Pele',
        hairLabel: 'Cabelo',
        hairColorLabel: 'Cor do cabelo',
        beardLabel: 'Barba',
        glassesLabel: 'Óculos',
        glassesColorLabel: 'Cor dos óculos',
        outfitLabel: 'Roupa',
        patternLabel: 'Padrão',
        primaryColorLabel: 'Cor principal',
        secondaryColorLabel: 'Cor secundária',
        secondaryColorHint: '(padrão / detalhes)',
        shortsLabel: 'Calção',
        socksLabel: 'Meias',
        bootsLabel: 'Chuteiras',
        bootsStyleLabel: 'Estilo de chuteiras',
        accessoryLabel: 'Acessório',
        accessoryColorLabel: 'Cor do acessório',
        creating: 'Criando...',
        createButton: 'Criar jogador',
        customColorTitle: 'Escolher outra cor',
    },

    avatar: {
        peinado: {
            shortFlat: 'Curto', shortWaved: 'Ondulado', shortCurly: 'Cacheado curto', shortRound: 'Raspado curto',
            theCaesar: 'César', theCaesarAndSidePart: 'César com risca', sides: 'Laterais raspadas',
            shavedSides: 'Raspado nas laterais', straight01: 'Liso', straight02: 'Liso 2',
            straightAndStrand: 'Liso com mecha', longButNotTooLong: 'Médio',
            frizzle: 'Frisado', curly: 'Cacheado', curvy: 'Ondulado longo', shaggy: 'Despenteado',
            bob: 'Chanel', fro: 'Afro', froBand: 'Afro + faixa', dreads01: 'Dreads',
            dreads02: 'Dreads 2', dreads: 'Dreads longos', bun: 'Coque', bigHair: 'Cabelão',
            shaggyMullet: 'Mullet', hat: 'Boné', turban: 'Turbante', winterHat1: 'Gorro', pelado: 'Careca',
        },
        barba: {
            ninguna: 'Sem barba', beardLight: 'Por fazer', beardMedium: 'Média',
            beardMajestic: 'Cheia', moustacheFancy: 'Bigode', moustacheMagnum: 'Bigodão',
        },
        lentes: {
            ninguno: 'Nenhum', round: 'Redondo', sunglasses: 'Escuro', wayfarers: 'Wayfarer',
            prescription01: 'De grau', prescription02: 'De grau 2', kurt: 'Kurt', eyepatch: 'Tapa-olho',
        },
        atuendo: {
            remera: 'Camiseta', remera_v: 'Camiseta gola V', manga_larga: 'Manga longa', buzo: 'Moletom',
            sueter: 'Suéter', campera: 'Jaqueta', traje: 'Terno', conjunto: 'Conjunto esportivo',
        },
        patron: {
            liso: 'Liso', rayas_v: 'Listras verticais', rayas_h: 'Listras horizontais', banda: 'Faixa',
        },
        botinEstilo: {
            clasico: 'Clássicas', altos: 'Cano alto', franja: 'Com listra',
        },
        accesorio: {
            ninguno: 'Nenhum', capitan: 'Braçadeira de capitão', vincha: 'Faixa de cabeça', guantes: 'Luvas', munequeras: 'Munhequeiras',
        },
    },

    clubPicker: {
        title: 'ESCOLHA SEU PRIMEIRO CLUBE',
        subtitle: '{{nombre}} · {{nacionalidad}} · {{posicion}} · Nota {{rating}}',
        hint: 'Estas são suas 3 opções para começar sua carreira. Escolha uma para continuar.',
        choose: 'Escolher',
        adminAnyClub: '🛠️ Admin: ir para qualquer clube',
    },

    header: {
        achievementsTooltip: 'Conquistas obtidas em todas as suas carreiras',
        achievements: 'Conquistas',
        calledUp: 'Convocado para a seleção',
        notCalledUp: 'O técnico ainda não te considera apto para a convocação',
        seasonLabel: 'Temporada {{n}}',
        ageYears: '{{n}} anos',
        marketValue: '💰 R${{n}}M',
        statsTooltip: 'Gols e assistências na temporada atual',
        contractTooltip: 'Temporadas restantes de contrato',
        contractYears_one: '📝 {{n}} ano',
        contractYears_other: '📝 {{n}} anos',
        suspended: '🟥 Suspenso {{n}}j',
    },

    next: {
        selectionNowTag: 'SELEÇÃO · AGORA',
        selectionNotCalledNote: '🚫 O técnico não te considerou apto para esta convocação: sua seleção joga sem você.',
        laterTag: 'DEPOIS',
        nowTag: 'AGORA',
        jornada: 'Rodada {{n}} · {{venue}}',
        home: 'Em casa',
        away: 'Fora',
        idaResultPrefix: '🔁 Ida: ',
        koAutoPauseNote: '⏸ O modo automático para em partidas eliminatórias.',
    },

    mobile: {
        results: '📋 Resultados',
        tables: '📊 Tabelas',
        selectionTab: '🌍 Seleção',
        cupTab: 'Copa',
        leagueTab: '🏆 Liga',
    },

    status: {
        moral: '😤 Moral',
        openTactics: '📋 Prancheta tática',
    },

    actions: {
        simulateFast: '⚡ Simular Rodada (Rápido)',
        simulateSlow: '🐢 Simular Rodada (Lento)',
        playEuroFast: '⚡ Jogar {{copa}} (Rápido)',
        playEuroSlow: '🐢 Jogar {{copa}} (Lento)',
        playSelectionFast: '⚡ Jogar pela Seleção (Rápido)',
        playSelectionSlow: '🐢 Jogar pela Seleção (Lento)',
        playMundialFast: '⚡ Jogar Copa do Mundo (Rápido)',
        playMundialSlow: '🐢 Jogar Copa do Mundo (Lento)',
        shortFast: '⚡ Rápido',
        shortSlow: '🐢 Lento',
        shortEuro: '⚡ {{copa}}',
        shortEuroSlow: '🐢 {{copa}}',
        shortSelection: '⚡ Seleção',
        shortSelectionSlow: '🐢 Seleção',
        shortMundial: '⚡ Copa do Mundo',
        shortMundialSlow: '🐢 Copa do Mundo',
        autoStart: '⏩ Simular Automático',
        autoStartShort: '⏩ Auto',
        autoStop: '⏸ Parar',
        attributes: '⚡ ATRIBUTOS',
        attributesShort: '⚡ Atr',
        seasonFinished: 'Temporada encerrada',
        simulating: 'Simulando...',
        fastTooltip: 'Simula a rodada instantaneamente, sem animação',
        slowTooltip: 'Simula a rodada com animação minuto a minuto da sua partida',
        autoTooltip: 'Avança rodadas automaticamente até o fim da temporada ou até chegar uma proposta',
        retire: '🎙️ Aposentar-se',
    },

    results: {
        title: 'Últimos resultados',
        suspended: '🟥 Suspenso',
    },

    careerHistory: {
        title: '🏆 Carreira',
    },

    tables: {
        club: 'Clube',
        country: 'País',
        played: 'J',
        won: 'V',
        drawn: 'E',
        lost: 'D',
        goalsFor: 'GP',
        goalsAgainst: 'GC',
        goalDiff: 'SG',
        points: 'Pts',
        group: 'Gr',
        legendLibertadores: 'Copa Libertadores',
        legendSudamericana: 'Copa Sul-Americana',
        legendChampions: 'Champions League',
        legendEuropa: 'Europa League',
        legendPromotion: 'Acesso',
        legendRelegation: 'Rebaixamento',
        legendLast16Direct: 'Oitavas (direto)',
        legendPlayoff16: 'Playoff oitavas',
        legendEliminated: 'Eliminado',
        legendLast16DirectShort: 'Oitavas',
        legendPlayoffShort: 'Playoff',
        conmebolOctavos2: 'Oitavas (1º e 2º)',
        conmebolOctavos1: 'Oitavas (1º)',
        conmebolDown: '3º → Sul-Americana',
        conmebol16: '16avos (2º)',
        tbd: 'A definir',
        groupLetter: 'Grupo {{letter}}',
        tableTitle: 'Tabela — {{nombre}}',
    },

    competitions: {
        champions: 'Champions League',
        europa: 'Europa League',
        libertadores: 'Copa Libertadores',
        sudamericana: 'Copa Sul-Americana',
        generic: 'Copa',
        groupStage: 'Fase de grupos',
        leaguePhase: 'Fase de liga',
        groupStageJ: 'Fase de grupos · R{{n}}',
        leaguePhaseJ: 'Fase de liga · R{{n}}',
        libertadoresGroupNote: '📋 Fase de grupos. 1º e 2º → oitavas. 3º cai para a Sul-Americana.',
        sudamericanaGroupNote: '📋 Fase de grupos. 1º → oitavas. 2º joga os 16avos contra um 3º da Libertadores.',
        leaguePhaseNote: '📋 Fase de liga. Top 8 → oitavas direto, 9-24 → playoff dos 16avos.',
        teamAlive: 'seu time segue vivo ✅',
        teamEliminated: 'seu time foi eliminado ❌',
        championYou: '🏆 Seu time é o CAMPEÃO!',
        championOther: '🏆 Campeão: {{nombre}}',
    },

    koRounds: {
        '16avos': 'Dezesseis-avos de final',
        octavos: 'Oitavas de final',
        cuartos: 'Quartas de final',
        semis: 'Semifinal',
        final: 'Final',
    },

    months: {
        1: 'Janeiro', 2: 'Fevereiro', 3: 'Março', 4: 'Abril', 5: 'Maio', 6: 'Junho',
        7: 'Julho', 8: 'Agosto', 9: 'Setembro', 10: 'Outubro', 11: 'Novembro', 12: 'Dezembro',
    },

    clasif: {
        uefaTexto: '1º → Copa do Mundo · 2º (e melhores 3os) → Repescagem · resto fora',
        uefaDetalle: '12 grupos. O 1º de cada grupo vai direto à Copa do Mundo (12 vagas). Os 12 segundos colocados + os 4 melhores terceiros disputam uma repescagem pelas 4 vagas restantes.',
        uefaPlayoffSub: '(os 12 segundos colocados de grupo também vão direto à repescagem)',
        asiaTexto: '1º e 2º → Copa do Mundo · melhor 3º → Repescagem · resto fora',
        asiaDetalle: '4 grupos. O 1º e o 2º de cada grupo vão direto à Copa do Mundo (8 vagas). Os 4 terceiros disputam uma repescagem por 1 vaga.',
        africaTexto: '1º → Copa do Mundo · 4 melhores 2os → Repescagem · resto fora',
        africaDetalle: '9 grupos. O 1º de cada grupo vai direto à Copa do Mundo (9 vagas). Os 4 MELHORES segundos colocados (entre os 9 grupos) disputam uma repescagem em jogo único; o vencedor leva a 10ª e última vaga africana.',
        concacafTexto: '1º → Copa do Mundo · 2º → Repescagem cruzada · resto fora',
        concacafDetalle: '4 grupos. O 1º de cada grupo vai direto à Copa do Mundo (4 vagas). Os 4 segundos se cruzam (G1-G3, G2-G4) em ida e volta pelas 2 vagas restantes.',
        conmebolTexto: '1º ao 6º → Copa do Mundo · resto fora',
        conmebolDetalle: 'Liga única (todos contra todos). Os 6 primeiros da tabela vão direto à Copa do Mundo.',
        oceaniaTexto: '1º → Copa do Mundo · resto fora',
        oceaniaDetalle: 'Liga única (todos contra todos). Só o líder da tabela vai à Copa do Mundo.',
        classifies: 'Classifica',
        playoff: 'Repescagem',
        bestSecondsTitle: 'Segundos colocados de cada grupo',
        bestThirdsTitle: 'Terceiros colocados de cada grupo',
        goesToPlayoffN: 'Vai para a repescagem (melhores {{n}})',
        mundialQualifyLegend: '1º e 2º → 16avos · melhores 3os também',
    },

    mundial: {
        bestThirdsTitle: '🥉 Melhores terceiros (8 avançam aos 16avos)',
        bestThirdsLegend: 'Avança aos 16avos (8 melhores terceiros)',
        groupStage: '🌍 Copa do Mundo · Fase de grupos',
        groupStageDate: '🌍 Copa do Mundo · Grupos (rodada {{n}}/3)',
        finished: '🌍 Copa do Mundo · Encerrada',
        round: '🌍 Copa do Mundo · {{ronda}}',
        finalRound: '🌍 Copa do Mundo · Final',
        eliminatedSpectator: '🌍 Copa do Mundo · Você está fora — veja como termina',
        notQualifiedSpectatorHint: 'Você não se classificou — acompanhe a Copa do Mundo. Avance para ver como continua.',
        championPrefix: '🏆 Campeão: ',
        runnerUpLabel: ' · 🥈 {{nombre}}',
        groupLabel: 'Grupo {{letra}}',
        bracketTitle: 'Chaveamento da Copa do Mundo',
        yourPath: 'Seu caminho',
        groupPhaseTitle: 'Fase de grupos',
        pendingBracketNote: 'O chaveamento vai se formando partida a partida.',
        outTitle: '🌍 Seleção · Eliminada',
        outOfWorldCup: 'Sua seleção está fora da Copa do Mundo.',
        outOfWorldCupSub: 'Você não joga mais pela seleção até as próximas eliminatórias (próximo ciclo).',
        playoffTitle: '🌍 Repescagem da Copa do Mundo',
        playoffLeg: '{{ronda}} · Ida',
        playoffLegVuelta: '{{ronda}} · Volta',
        playoffRoundIda: 'Repescagem · Ida',
        playoffRoundVuelta: 'Repescagem · Volta',
        playoffRound: 'Repescagem',
        playoffSummaryPre: 'Confronto de ida e volta contra ',
        playoffSummaryPost: ' pela última vaga. Agregado {{favor}}-{{contra}}.',
        playoffNote: 'Vence no agregado → Copa do Mundo. Perde → fora.',
        prePlayoffTitle: '🌍 Pré-repescagem da CONCACAF',
        prePlayoffSummary: 'Você é do pote 4: vença 2 rodadas para entrar na fase de grupos.',
        qualifiedTitle: '🌍 ✅ Classificado para a Copa do Mundo',
        qualifiedNote: 'Sua seleção vai disputar a próxima Copa do Mundo!',
        qualifyingTitle: '🌍 Eliminatórias · Ano {{n}}/4',
    },

    modals: {
        attributes: {
            title: '⚡ Atributos · {{posicion}}',
            ratingLabel: 'Nota',
            pointsLabel: 'Pontos a distribuir:',
            resetButton: '♻️ Resetar tudo (custa 1 ponto)',
            removeAria: 'Remover',
            addAria: 'Adicionar',
        },
        achievements: {
            title: '🏆 Conquistas',
            subtitle: 'Salvas entre todas as suas carreiras, com a data e o clube com que você as conseguiu. O progresso das conquistas de uma única carreira é reiniciado ao começar outra.',
            close: 'Fechar',
        },
        callup: {
            title: 'Parabéns!',
            textPre: 'Você foi convocado para a ',
            textMid: ' pela seleção de ',
            textPost: '.',
            worldCupWord: 'Copa do Mundo',
            text2: 'O sonho de todo jogador! Dê tudo de si em campo. 🏆',
            button: 'Vamos!',
        },
        seleccion: {
            calledUp: '⭐ Convocado para a seleção',
            notCalledUp: '🚫 O técnico ainda não te considera apto para a convocação.',
            phaseClasif: '🟡 Eliminatórias em andamento',
            phaseClasificado: '✅ Classificado para a Copa do Mundo',
            phasePlayoff: '⚠️ Na repescagem',
            phaseEliminado: '❌ Eliminado',
            cycleLine: ' · Ciclo {{ciclo}} / Ano {{año}}/4',
            outOfWorldCup: 'Sua seleção está fora da Copa do Mundo.',
            outOfWorldCupSub: 'Você não joga mais pela seleção até as próximas eliminatórias (próximo ciclo).',
            groupTableTitle: 'Tabela do grupo',
            upcomingTitle: 'Próximas partidas',
            upcomingLine: 'Ano {{año}} · {{venue}} {{rival}} ({{estrellas}})',
            cycleStats: '📊 Este ciclo: <b>{{pj}}</b> J · <b>{{g}}</b> G · <b>{{a}}</b> A',
            careerStats: '🌍 Carreira: <b>{{pj}}</b> J · <b>{{g}}</b> G · <b>{{a}}</b> A · <b>{{w}}</b> Copas do Mundo',
        },
        season: {
            title: 'Temporada {{n}} encerrada',
            finishedLine: 'Você terminou em {{pos}}{{ord}} em {{liga}}.',
            yourLeague: 'sua liga',
            played: 'Jogos',
            goals: 'Gols',
            assists: 'Assistências',
            minutes: 'Minutos',
            ratingLine: 'Nota: {{prev}} → {{next}}',
            marketValueLine: 'Valor de mercado: R${{n}}M',
            promoted: '🔼 Você subiu para a Primeira Divisão!',
            relegated: '🔽 Você caiu para a Segunda Divisão.',
        },
        liveMatch: {
            fallbackHeader: 'Rodada {{n}} · {{venue}}',
            qualifiersHeader: '🌍 Eliminatórias da Copa do Mundo · Ano {{n}}/3{{nc}}',
            notCalledShort: ' · 🚫 Não convocado',
            prePlayoffHeader: '🌍 Pré-repescagem da CONCACAF · {{ronda}}',
            playoffHeader: '🌍 Repescagem da Copa do Mundo · {{ronda}}{{leg}}',
            legIda: ' · Ida',
            legVuelta: ' · Volta',
            mundialGroupHeader: '🌍 Copa do Mundo · Fase de grupos · Rodada {{n}}',
            mundialKOHeader: '🌍 Copa do Mundo · {{ronda}}',
            secondLegLine: '🔁 Volta · ida: <bold>{{score}}</bold> (agregado se define aqui)',
            penaltiesTitle: '🥅 Disputa de pênaltis',
            suddenDeath: 'Morte súbita',
            advancedPens: '✅ Você avançou {{favor}}-{{contra}} nos pênaltis!',
            eliminatedPens: '❌ Eliminado {{contra}}-{{favor}} nos pênaltis',
            kickingOn: 'Batendo…',
            ownGoal: '⚽ Gol seu',
            ownAssist: '🅰️ Assistência sua',
            opponentGoal: '⚽ {{equipo}}',
            goalFlashOwn: "⚽ SEU GOL! ({{min}}')",
            goalFlashOwnAssist: "🅰️ Sua assistência! ({{min}}')",
            goalFlashOther: "⚽ Gol de {{equipo}} ({{min}}')",
        },
        evento: {
            title: 'Evento',
        },
        tacticas: {
            title: '📋 Prancheta tática',
            done: 'Pronto',
        },
        transfer: {
            titleDefault: 'Propostas de transferência',
            textDefault_one: 'Você tem {{n}} proposta de transferência. O que você quer fazer?',
            textDefault_other: 'Você tem {{n}} propostas de transferência. O que você quer fazer?',
            titleExpiredRenewal: 'Seu contrato venceu',
            textExpiredRenewal: 'Seu clube quer te renovar, mas outros times também te querem. Escolha renovar ou assinar com outro clube.',
            titleExpiredNoRenewal: 'Seu clube não vai te renovar',
            textExpiredNoRenewal: 'Seu clube decidiu não renovar seu contrato. Você precisa escolher um dos clubes a seguir.',
            renewalTag: ' · Renovação',
            minutesWarn: "⚠️ Você vai jogar muito pouco (~{{n}}'/jogo)",
            minutesLimited: "🟡 Minutos limitados (~{{n}}'/jogo)",
            minutesStarter: "✅ Titular (~{{n}}'/jogo)",
            renewalContract_one: '📝 Contrato de {{n}} ano',
            renewalContract_other: '📝 Contrato de {{n}} anos',
            offerContract_one: '{{monto}}M · 📝 {{n}} ano',
            offerContract_other: '{{monto}}M · 📝 {{n}} anos',
            finishedFinal: 'terminou',
            goingPos: 'está em',
            renew: 'Renovar',
            sign: 'Assinar',
            stay: 'Ficar no meu clube',
            adminAnyClub: '🛠️ Admin: ir para qualquer clube',
        },
        adminClubPicker: {
            title: '🛠️ Admin: ir para qualquer clube',
            hint: 'Apenas para testes. Te contrata na hora pelo clube escolhido, sem passar por propostas.',
            searchPlaceholder: 'Buscar clube, liga ou país...',
            go: 'Ir',
            close: 'Fechar',
        },
        retire: {
            forcedBanner: 'Aos {{n}} anos você diz adeus ao futebol profissional. Que carreira!',
            cardTitle: '⚽ FOOTY · CARREIRA DE ELITE',
            statsTitle: 'Estatísticas',
            statPartidos: 'JOGOS',
            statGoles: 'GOLS',
            statAsistencias: 'ASSISTÊNCIAS',
            statTitulos: 'TÍTULOS',
            trophiesTitle: 'Títulos',
            league_one: 'Liga',
            league_other: 'Ligas',
            nationalTeamTitle: 'Seleção Nacional',
            bestLine: 'Melhor: Copa do Mundo ciclo {{ciclo}} (idade {{edad}}) — {{result}}',
            bestLineWith: ' com {{pais}}',
            worldCupHash: 'Copa do Mundo #{{ciclo}} · idade {{edad}}',
            careerTitle: 'Trajetória',
            footer: 'Jogue sua carreira em www.footy-games.com.ar',
            share: '📸 Compartilhar',
            download: '📥 Baixar',
            generating: 'Gerando…',
            backButton: 'Voltar',
            newCareer: 'Começar nova carreira',
            confirmRetire: 'Confirmar aposentadoria',
        },
        nationality: {
            title: 'Escolha sua nacionalidade',
            close: 'Fechar',
        },
    },

    toast: {
        offerPending: 'Você precisa decidir a proposta de transferência antes de continuar.',
        matchdayError: 'Erro ao avançar a rodada.',
        loadCareerError: 'Erro ao carregar sua partida.',
        loadClubOptionsError: 'Erro ao buscar opções de clube.',
        gameError: 'Erro ao criar a partida.',
        chooseClubError: 'Erro ao escolher o clube.',
        adminChangeClubError: 'Erro ao trocar de clube (admin).',
        adminNowAt: '(Admin) Agora você joga no {{nombre}}.',
        signedWith: 'Contratado pelo {{nombre}}!',
        couldNotSave: 'Não foi possível salvar seu progresso. Verifique sua conexão e tente de novo.',
        offerProcessError: 'Erro ao processar a proposta. Tente de novo.',
        nameRequired: 'Digite um nome para o seu jogador.',
        nationalityRequired: 'Escolha sua nacionalidade.',
        attributesUpdated: 'Atributos atualizados.',
        seasonFinished: 'Temporada encerrada!',
        seasonFinishedShort: 'Temporada encerrada.',
        dayOff: 'Seu time descansou nesta rodada.',
        koPauseNote: '⏸ É uma partida eliminatória: jogue você mesmo (Rápido ou Lento).',
        selectionTurnNote: '🌍 É sua vez pela seleção! Jogue a partida você mesmo (Rápido ou Lento).',
        mundialTurnNote: '🌍 Você está na Copa do Mundo. Jogue as partidas você mesmo (Rápido ou Lento).',
        worldCupGroupsDone: '🌍 Copa do Mundo: a fase de grupos terminou. Começam os 16avos.',
        worldCupGroupDate: '🌍 Copa do Mundo: foi disputada a rodada {{n}}/3 dos grupos.',
        worldCupFinished: '🌍 Copa do Mundo encerrada! Campeão: {{campeon}}.',
        worldCupRoundPlayed: '🌍 Copa do Mundo: foram disputados os {{ronda}}.',
        worldCupRoundPlayedWatch: '🌍 Copa do Mundo: foram disputados os {{ronda}}. Veja como segue o chaveamento.',
        worldCupKOAdvance: '🌍 Você avançou de fase! {{ronda}}: seu adversário é {{rival}}.',
        worldCupStartedNotCalled: '🌍 Começa a Copa do Mundo. O técnico não te considerou apto para esta convocação: sua seleção joga sem você. Você pode acompanhar no painel.',
        suspendedLeague: '🟥 Suspenso por cartão vermelho: você perde esta rodada do campeonato.',
        wonLost: { won: 'Você venceu', lost: 'Você perdeu', drawn: 'Você empatou' },
        notCalledScore: '🌍 {{ronda}}: 🚫 Não convocado — sua seleção jogou sem você {{score}} {{venue}} {{rival}}',
        prePlayoffToGroups: '   ✅ Para a fase de grupos!',
        prePlayoffEliminated: '   ❌ Eliminado na pré-repescagem',
        playoffQualified: '   ✅ Classificado para a Copa do Mundo!',
        playoffEliminated: '   ❌ Você ficou fora da Copa do Mundo',
        worldChampion: '   🏆 CAMPEÃO DO MUNDO!',
        nextRound: '   ✅ Avançou para a próxima rodada',
        eliminatedWC: '   ❌ Eliminado da Copa do Mundo',
        suspendedCup: '🟥 Suspenso — seu time jogou sem você {{score}} {{venue}} {{rival}}',
        aggregateScore: '   Agregado {{favor}}-{{contra}}{{pens}}',
        aggregatePens: ' · Pênaltis {{favor}}-{{contra}}',
        champion: '   🏆 CAMPEÃO!',
        qualifiedNextRound: '   ✅ Classificado para a próxima rodada',
        eliminatedCup: '   ❌ Eliminado da competição',
        imageDownloadedCopied: 'Imagem baixada e texto copiado. Cole no seu post 📸',
        imageDownloaded: 'Imagem da sua carreira baixada 📸',
        imageDownloaded2: 'Imagem da sua carreira baixada 📥',
        imageError: 'Não foi possível gerar a imagem.',
        retireError: 'Erro ao se aposentar.',
        achievementUnlocked: '🏆 Conquista desbloqueada! {{titulo}}',
        eliminatorias: 'Eliminatórias · Ano {{n}}/3',
        prePlayoff: 'Pré-repescagem da CONCACAF',
        playoffIda: 'Repescagem (ida)',
        playoffVuelta: 'Repescagem (volta)',
        playoffPlain: 'Repescagem',
        worldCupGroupMatchday: 'Copa do Mundo · Rodada {{n}}',
        worldCupKO: 'Copa do Mundo · {{ronda}}',
        selectionGeneric: 'Seleção',
    },

    share: {
        text: 'Pendurei as chuteiras 🎙️\n\nMinha carreira como {{nombre}} ({{posicion}}):\n⚽ {{goles}} gols · 🅰️ {{asistencias}} assistências em {{partidos}} jogos\n{{palmares}}\n📈 Melhor nota {{rating}}\n\nJogue sua carreira em www.footy-games.com.ar!',
        league_one: 'liga',
        league_other: 'ligas',
        statsTitle: 'Estatísticas',
        statPartidos: 'JOGOS',
        statGoles: 'GOLS',
        statAsistencias: 'ASSISTÊNCIAS',
        statTitulos: 'TÍTULOS',
        bestRatingLabel: 'MELHOR NOTA',
        trophiesTitle: 'Títulos',
        nationalTeamTitle: 'Seleção Nacional',
        careerTitle: 'Trajetória',
        footer: 'Jogue sua carreira em www.footy-games.com.ar',
        season_one: 'temporada',
        season_other: 'temporadas',
        year_one: 'ano',
        year_other: 'anos',
        mundial_one: 'Copa do Mundo',
        mundial_other: 'Copas do Mundo',
        bestLine: 'Melhor: Copa do Mundo ciclo {{ciclo}} (idade {{edad}})',
        header: '⚽  FOOTY · CARREIRA DE ELITE',
        shareTitle: 'Minha carreira no Footy',
        selChipGoals: 'Gols',
        selChipAssists: 'Assist.',
        selChipMatches: 'J',
        mundialRow: 'Copa #{{ciclo}} · idade {{edad}}',
        clubStatsRow: '{{pj}} J · {{g}} G · {{a}} A',
        selStatsRow: '{{pj}} J · {{g}}G',
    },

    tactica: {
        axis: { formacion: 'Formação', actitud: 'Postura', presion: 'Pressão', estilo: 'Estilo de ataque', marca: 'Marcação' },
        values: {
            defensiva: 'Defensiva', equilibrada: 'Equilibrada', ofensiva: 'Ofensiva', todo_o_nada: 'Tudo ou nada',
            repliegue: 'Recuada', media: 'Média', alta: 'Pressão alta',
            posesion: 'Posse de bola', directo: 'Jogo direto', bandas: 'Pelas pontas', contra: 'Contra-ataque',
            zona: 'Por zona', hombre: 'Homem a homem',
        },
    },

    attributes: {
        velocidad: 'Velocidade', tiro: 'Finalização', fisico: 'Físico', pase: 'Passe',
        defensa: 'Capacidade Defensiva', fiesta: 'Festa e Álcool',
    },

    positions: {
        'Defensor Lateral': 'Lateral',
        'Defensor Central': 'Zagueiro',
        'Mediocampista Defensivo': 'Volante',
        'Mediocampista Ofensivo': 'Meia-atacante',
        'Delantero Extremo': 'Ponta',
        'Delantero Centro': 'Centroavante',
    },

    mundialResult: { campeon: '🏆 Campeão', final: '🥈 Final', semis: 'Semifinal', cuartos: 'Quartas', octavos: 'Oitavas', '16avos': '16avos', grupos: 'Fase de grupos', no_clasif: 'Não classificou' },

    scouting: {
        defensiva: '🕵️ Eles vão recuar.',
        equilibrada: '🕵️ Vão jogar equilibrado, sem arriscar.',
        ofensiva: '🕵️ Vão sair pra cima de você.',
        todo_o_nada: '🕵️ Vão para o tudo ou nada no ataque.',
        repliegue: '🕵️ Esperam recuados.',
        media: '🕵️ Pressionam no campo deles.',
        alta: '🕵️ Vêm te pressionar lá na frente.',
        posesion: '🕵️ Gostam de ter a bola.',
        directo: '🕵️ Jogam direto, para o espaço.',
        bandas: '🕵️ Atacam muito pelas pontas.',
        contra: '🕵️ Esperam para sair no contra-ataque.',
    },

    tacticaFeedback: {
        messyWin: '🤔 Esquema meio bagunçado, mas você levou a melhor.',
        messyLose: '🤯 Seu esquema foi contraditório e isso apareceu em campo.',
        sharpWin: '🧠 Você leu o rival perfeitamente: seu esquema os destruiu.',
        sharpLose: '🧠 Esquema certeiro, faltou eficácia lá na frente.',
        outreadWin: '😮‍💨 O rival te venceu na estratégia, mas você escapou.',
        outreadLose: '❌ Leram seu esquema e passaram por cima de você.',
        neatWin: '✅ Esquema correto e vitória.',
        neatDraw: '➖ Esquema equilibrado, dividiram os pontos.',
        neatLose: '🔻 Esquema correto, mas não deu certo dessa vez.',
    },

    achievements: {
        facil_5_ligas: { title: 'Pentacampeão local', desc: 'Vencer 5 ligas locais em uma mesma carreira.' },
        facil_champions: { title: 'Rei da Europa', desc: 'Vencer uma Champions League.' },
        facil_europa: { title: 'Conquista continental', desc: 'Vencer uma Europa League.' },
        facil_sudamericana: { title: 'Glória sul-americana', desc: 'Vencer uma Copa Sul-Americana.' },
        facil_libertadores: { title: 'A Glória Eterna', desc: 'Vencer uma Copa Libertadores.' },
        facil_5_grandes: { title: 'Andarilho de elite', desc: 'Jogar nas 5 grandes ligas (Espanha, França, Inglaterra, Itália, Alemanha) da primeira divisão em uma mesma carreira.' },
        facil_media_85: { title: 'Destaque', desc: 'Chegar a 85 de nota em uma temporada.' },
        sel_facil_convocado: { title: 'Convocado', desc: 'Ser convocado para a sua seleção pelo menos uma vez.' },
        sel_facil_5_goles: { title: 'Artilheiro da seleção', desc: 'Fazer 25 gols pela sua seleção em uma mesma carreira.' },
        sel_facil_clasificar: { title: 'Para a Copa do Mundo', desc: 'Classificar para uma Copa do Mundo com sua seleção.' },
        medio_5_ligas_5_equipos: { title: 'Campeão nômade', desc: 'Vencer 5 ligas locais com 5 clubes diferentes em uma mesma carreira.' },
        medio_3_intl_3_equipos: { title: 'Andarilho campeão', desc: 'Vencer 3 títulos internacionais com 3 clubes diferentes em uma mesma carreira.' },
        medio_5_ligas_mismo: { title: 'Ídolo eterno', desc: 'Vencer 5 ligas locais pelo mesmo clube.' },
        medio_remontada_0_3: { title: 'Virada épica', desc: 'Virar uma partida depois de estar perdendo de 3-0.' },
        medio_3_clubs_5est: { title: 'Só para cracks', desc: 'Jogar em 3 clubes de 5 estrelas de avaliação em uma mesma carreira.' },
        medio_45_atrib: { title: 'Físico de elite', desc: 'Aplicar 45 pontos de atributos em uma mesma carreira.' },
        medio_750_goles: { title: 'Máquina de gols', desc: 'Fazer mais de 750 gols em uma mesma carreira.' },
        medio_media_90: { title: 'Crack', desc: 'Chegar a 90 de nota em uma temporada.' },
        medio_liber_liga: { title: 'Dobradinha sul-americana', desc: 'Vencer a Libertadores e a liga local na mesma temporada.' },
        medio_champ_liga: { title: 'Dobradinha europeia', desc: 'Vencer a Champions e a liga local na mesma temporada.' },
        sel_medio_semifinal: { title: 'Entre os 4 melhores', desc: 'Chegar à semifinal da Copa do Mundo com sua seleção.' },
        sel_medio_gol_ko: { title: 'Gol no mata-mata', desc: 'Fazer um gol na Copa do Mundo em uma partida eliminatória (16avos em diante).' },
        sel_medio_clasif_15est: { title: 'Cinderela mundial', desc: 'Classificar para uma Copa do Mundo com uma seleção de 1.5 estrelas ou menos.' },
        sel_medio_final_35est: { title: 'Surpresa da Copa', desc: 'Chegar à final da Copa do Mundo com uma seleção de 3.5 estrelas ou menos.' },
        sel_medio_25_goles: { title: 'Artilheiro da seleção', desc: 'Fazer mais de 50 gols pela sua seleção em uma mesma carreira.' },
        dificil_900_goles: { title: 'Lenda artilheira', desc: 'Fazer mais de 900 gols em uma mesma carreira.' },
        dificil_750_asist: { title: 'Gerador de jogo', desc: 'Fazer mais de 750 assistências em uma mesma carreira.' },
        imposible_900_asist: { title: 'Mago das assistências', desc: 'Fazer mais de 900 assistências em uma mesma carreira.' },
        dificil_sudam_2est: { title: 'Cinderela sul-americana', desc: 'Vencer uma Sul-Americana com um clube de 2 estrelas ou menos.' },
        dificil_europa_25est: { title: 'Surpresa europeia', desc: 'Vencer uma Europa League com um clube de 2.5 estrelas ou menos.' },
        dificil_intl_invicto: { title: 'Caminho perfeito', desc: 'Vencer um torneio internacional invicto.' },
        dificil_liber_cada_pais: { title: 'Dono da Libertadores', desc: 'Vencer uma Libertadores com cada país da América do Sul (não necessariamente na mesma carreira).' },
        dificil_sudam_cada_pais: { title: 'Dono da Sul-Americana', desc: 'Vencer uma Sul-Americana com cada país da América do Sul (não necessariamente na mesma carreira).' },
        dificil_champ_cada_pais: { title: 'Dono da Champions', desc: 'Vencer uma Champions com cada país da Europa (não necessariamente na mesma carreira).' },
        dificil_europa_cada_pais: { title: 'Dono da Europa League', desc: 'Vencer uma Europa League com cada país da Europa (não necessariamente na mesma carreira).' },
        dificil_media_95: { title: 'Super crack', desc: 'Chegar a 95 de nota em uma temporada.' },
        dificil_50_atrib: { title: 'Potencial máximo', desc: 'Aplicar 50 pontos de atributos em uma mesma carreira.' },
        dificil_un_club: { title: 'Eterno e inquebrável', desc: 'Jogar toda a carreira no mesmo clube e se aposentar por idade (não vale aposentadoria voluntária).' },
        sel_dificil_campeon: { title: 'Campeão do Mundo', desc: 'Ser campeão da Copa do Mundo com sua seleção.' },
        sel_dificil_gol_final: { title: 'Gol na final', desc: 'Fazer um gol na final da Copa do Mundo com sua seleção.' },
        sel_dificil_5_mundiales: { title: 'Cinco Copas do Mundo', desc: 'Disputar 5 Copas do Mundo diferentes.' },
        sel_dificil_8_goles_mun: { title: 'Chuteira de Ouro', desc: 'Fazer mais de 8 gols em uma mesma Copa do Mundo.' },
        sel_dificil_50_goles: { title: 'Lenda da seleção', desc: 'Fazer mais de 75 gols pela sua seleção em uma mesma carreira.' },
        imposible_un_club_3est: { title: 'Lenda de um só clube', desc: 'Jogar toda a carreira no mesmo clube de no mínimo 3 estrelas de avaliação e se aposentar por idade (não vale aposentadoria voluntária).' },
        imposible_libertadores_2est: { title: 'Milagre libertador', desc: 'Vencer uma Libertadores com um clube de 2 estrelas ou menos.' },
        imposible_champions_25est: { title: 'Feito imortal', desc: 'Vencer uma Champions com um clube de 2.5 estrelas ou menos.' },
        imposible_liga_invicto_18: { title: 'Os Invencíveis', desc: 'Vencer uma liga local de 18 ou mais times invicto (primeira divisão).' },
        imposible_media_99: { title: 'O melhor da história', desc: 'Chegar a 99 de nota em uma temporada.' },
        sel_imp_campeon_2est: { title: 'Façanha mundial', desc: 'Ser campeão da Copa do Mundo com uma seleção de 2 estrelas ou menos.' },
        sel_imp_12_goles_mun: { title: 'Just \'Like\' Fontaine', desc: 'Fazer no mínimo 13 gols em uma mesma Copa do Mundo.' },
        sel_imp_3_mundiales_gan: { title: 'O\'Rei Pelé', desc: 'Vencer 3 Copas do Mundo em uma mesma carreira.' },
        sel_imp_75_goles: { title: 'Artilheiro histórico', desc: 'Fazer mais de 100 gols pela sua seleção em uma mesma carreira.' },
    },
    eventos: {
            "fiesta_previa": {
                texto: "Te convidam pra uma festa na noite anterior a um jogo importante.",
                opt0: { label: "🍻 Vou com tudo", out0: "Mandou muito bem e no dia seguinte tava numa boa. (+moral)", out1: "Chegou destruído e o técnico te encheu o saco. (−moral)" },
                opt1: { label: "🍷 Vou um pouco e saio cedo", out0: "Cumprimentou todo mundo e descansou. Equilíbrio. (+moral)", out1: "Saiu bem na hora que ficou boa. Aff." },
                opt2: { label: "🛌 Fico descansando", out0: "Profissional total. (+moral)", out1: "Não dormiu direito pensando no que tava perdendo. (−moral)" },
            },
            "entreno_extra": {
                texto: "O preparador físico te chama pra fazer um trabalho extra.",
                opt0: { label: "💪 Vou com tudo no treino", out0: "O esforço valeu a pena: +1 ponto de atributo.", out1: "Se exigiu demais e ficou com um incômodo. (−moral)" },
                opt1: { label: "🏃 Faço um pouco só", out0: "Somou sem arriscar. (+moral)", out1: "Trote leve e pra casa. Normal." },
                opt2: { label: "🚗 Vou pra casa", out0: "Descansou. Nada de novo.", out1: "O treinador achou falta de comprometimento. (−moral)" },
            },
            "sponsor": {
                texto: "Uma marca te oferece pra ser o rosto da campanha.",
                opt0: { label: "✍️ Assino o contratão", out0: "Sua cara em todo lugar, subiu o astral. (+moral)", out1: "A campanha foi um vexame e te zoaram. (−moral)" },
                opt1: { label: "🤝 Negocio condições melhores", out0: "Conseguiu mais grana com paciência. (+moral)", out1: "Pediu demais e caiu tudo. (−moral)" },
                opt2: { label: "🙅 Passo", out0: "Perfil baixo, foco no futebol. (+moral)", out1: "Seus colegas te chamaram de bobo por causa da grana. (−moral)" },
            },
            "prensa": {
                texto: "Um jornalista fala que você tá supervalorizado.",
                opt0: { label: "🔥 Respondo forte", out0: "Rebateu com classe, a torcida te apoiou. (+moral)", out1: "Se estressou demais e ficou mal na fita. (−moral)" },
                opt1: { label: "😏 Solto uma alfinetada fina", out0: "Deixou ele sem resposta. Gênio. (+moral)", out1: "Ninguém entendeu sua ironia. Passou." },
                opt2: { label: "😶 Ignoro", out0: "Você fala com os pés. (+moral)", out1: "Seu silêncio foi lido como se ele tivesse razão. (−moral)" },
            },
            "vestuario": {
                texto: "Tem tensão no vestiário entre duas referências do time.",
                opt0: { label: "🕊️ Ajo pra acalmar os ânimos", out0: "Você apaziguou, te veem como líder. (+moral)", out1: "Se meteu onde não devia. (−moral)" },
                opt1: { label: "🤐 Fico neutro", out0: "Não tomou partido. Sensato.", out1: "Passou sem sua interferência." },
                opt2: { label: "🍿 Jogo lenha na fogueira", out0: "A confusão aumentou e apareceu em campo. (−moral)", out1: "Se divertiu com o climão. (+moral leve)" },
            },
            "molestia": {
                texto: "Você tá com um incômodo e o departamento médico te deixa escolher.",
                opt0: { label: "🏃 Forço e jogo", out0: "Aguentou e rendeu. Imbatível. (+moral)", out1: "Piorou feio. (−moral)" },
                opt1: { label: "💊 Tomo uma infiltração e vejo", out0: "Aguentou o jogo na base da raça. (+moral leve)", out1: "A infiltração te deixou pior. (−moral)" },
                opt2: { label: "🧊 Descanso e me cuido", out0: "Volta inteiro. (+moral)", out1: "Era besteira, perdeu o jogo à toa. (−moral)" },
            },
            "hincha": {
                texto: "Um garoto espera 3 horas na porta do clube pra te conhecer.",
                opt0: { label: "🤗 Assino autógrafo e tiro fotos", out0: "O vídeo viralizou, você é o queridinho. (+moral)", out1: "Alegrou o dia dele. Lindo. (+moral)" },
                opt1: { label: "✋ Cumprimento de passagem", out0: "Gesto curtinho mas gentil. (+moral leve)", out1: "Mal deu pra ver. Passou." },
                opt2: { label: "🏃 Tô com pressa, outro dia", out0: "Deixou ele na mão e saiu nas redes. (−moral)", out1: "Tinha médico, entenderam." },
            },
            "casino": {
                texto: "Uns colegas te chamam pro cassino depois do jogo.",
                opt0: { label: "🎲 Aposto forte", out0: "Se encheu de fichas. (+moral)", out1: "Perdeu grana e horas de sono. (−moral)" },
                opt1: { label: "🍹 Vou só acompanhar", out0: "Relaxou sem gastar. (+moral leve)", out1: "Um suco e pra casa. Tranquilo." },
                opt2: { label: "🏠 Volto pra casa", out0: "Cabeça fria. (+moral leve)", out1: "Perdeu uma noite épica. (−moral)" },
            },
            "asado": {
                texto: "Churrasco do elenco e a churrasqueira ficou com você.",
                opt0: { label: "🔥 Assumo a churrasqueira", out0: "Churrasco nível Deus, conquistou o vestiário. (+moral)", out1: "Queimou a carne e te zoaram. (−moral)" },
                opt1: { label: "🥗 Cuido das saladas", out0: "Cumpriu sem arriscar. (+moral leve)", out1: "Ninguém comeu salada. Aff." },
                opt2: { label: "🥤 Só levo as bebidas", out0: "Missão simples cumprida.", out1: "Trouxe refrigerante quente. Vexame. (−moral)" },
            },
            "tatuaje": {
                texto: "Você quer fazer uma tatuagem antes do torneio.",
                opt0: { label: "🖊️ O escudo gigante no braço", out0: "A torcida amou, virou ídolo. (+moral)", out1: "Ficou horrível e você quer tirar. (−moral)" },
                opt1: { label: "🤏 Algo pequeno e discreto", out0: "Sutil e estiloso. (+moral leve)", out1: "Ninguém percebeu." },
                opt2: { label: "🚫 Melhor não fazer nada", out0: "Zero arrependimentos.", out1: "Ficou com vontade. (−moral leve)" },
            },
            "representante": {
                texto: "Seu empresário diz que consegue te levar pra um clube maior \"agora mesmo\".",
                opt0: { label: "🌍 Confio na hora", out0: "Te iludiu com um timaço. (+moral)", out1: "Era tudo fumaça. (−moral)" },
                opt1: { label: "📑 Peço pra ele mostrar tudo por escrito", out0: "Profissional, se protegeu. (+moral)", out1: "Não tinha nada concreto. Passou." },
                opt2: { label: "🧐 Digo pra ele se acalmar", out0: "Pés no chão. (+moral leve)", out1: "Era uma proposta real e você perdeu. (−moral)" },
            },
            "mediatico": {
                texto: "Você começa a namorar uma celebridade e a mídia explode.",
                opt0: { label: "📺 Curto a fama", out0: "Levou numa boa e se divertiu. (+moral)", out1: "O circo te desconcentrou de vez. (−moral)" },
                opt1: { label: "🤫 Mantenho em segredo", out0: "Perfil baixo, cabeça no futebol. (+moral)", out1: "Vazou de qualquer jeito e você ficou de mentiroso. (−moral)" },
                opt2: { label: "🚪 Termino, me distrai", out0: "Foco total. (+moral leve)", out1: "Ficou pensando no que deixou. (−moral)" },
            },
            "var": {
                texto: "No fim de semana o VAR anulou um golaço seu e as redes ainda estão a seu favor.",
                opt0: { label: "😡 Saio xingando o VAR", out0: "A torcida te apoiou até o fim. (+moral)", out1: "Levou suspensão. (−moral)" },
                opt1: { label: "🤷 Solto um comentário irônico", out0: "Ficou engraçado e estiloso. (+moral)", out1: "Ninguém deu bola." },
                opt2: { label: "🙏 Deixo passar", out0: "Tranquilo, a revanche vem. (+moral)", out1: "Por dentro ficou irritado a semana toda. (−moral)" },
            },
            "auto": {
                texto: "Com o primeiro salário grande você quer comprar um carro caríssimo.",
                opt0: { label: "🤑 Compro o mais caro", out0: "Estilo total. (+moral)", out1: "Bateu na primeira semana. Vexame. (−moral)" },
                opt1: { label: "🚙 Algo bonito mas sensato", out0: "Bom gosto e prudência. (+moral leve)", out1: "Carro normalzinho. Cumpre." },
                opt2: { label: "🏦 Prefiro guardar", out0: "Sua mãe orgulhosa. (+moral)", out1: "Ficou com vontade. Aff." },
            },
            "tarde": {
                texto: "Você dormiu demais e chega atrasado ao treino.",
                opt0: { label: "🏃 Invento uma desculpa", out0: "Escapou com um \"furou o pneu\".", out1: "O técnico não acreditou e te multou. (−moral)" },
                opt1: { label: "🤐 Entro quieto e disfarço", out0: "Ninguém te viu entrar. Sorte.", out1: "Pegaram você do mesmo jeito. (−moral)" },
                opt2: { label: "📞 Aviso e assumo a multa", out0: "Sinceridade valorizada. (+moral)", out1: "Mesmo assim ficou de atrasado. (−moral)" },
            },
            "foto_filtrada": {
                texto: "Vazou uma foto sua numa balada às 4 da manhã.",
                opt0: { label: "😎 Assumo, \"tava de folga\"", out0: "Riu de si mesmo, virou piada. (+moral)", out1: "A diretoria te chamou atenção feio. (−moral)" },
                opt1: { label: "🙈 Peço desculpas públicas", out0: "Apagou o incêndio. Lição aprendida. (+moral)", out1: "No final a foto era feita por IA, nem era você. Se queimou à toa. (−moral)", out2: "Ninguém ligou pro seu pedido de desculpas." },
                opt2: { label: "🤐 Não digo nada", out0: "Esqueceram em dois dias.", out1: "O silêncio foi interpretado como culpa. (−moral)" },
            },
            "tv_baile": {
                texto: "Te convidam pra um programa de dança em plena temporada.",
                opt0: { label: "🕺 Aceito, sou uma estrela", out0: "Mandou bem dançando, ganhou fãs. (+moral)", out1: "Foi vexame e ainda chegou cansado no treino. (−moral)" },
                opt1: { label: "📅 Aceito mas só na pausa", out0: "Administrou sem descuidar do futebol. (+moral)", out1: "Ficou pra depois. Aff." },
                opt2: { label: "🙅 Não, tô focado", out0: "Trabalho em primeiro lugar. (+moral)", out1: "Quem foi ficou famoso. (−moral)" },
            },
            "comedor": {
                texto: "Uma cozinha comunitária do bairro pede uma ajuda pras crianças.",
                opt0: { label: "🤝 Doo e vou cumprimentar", out0: "Alegrou a vida deles, não tem preço. (+moral)", out1: "Gesto bonito, apesar da chuva que pegou você. (+moral)" },
                opt1: { label: "💸 Mando dinheiro mas não vou", out0: "Ajudou do mesmo jeito. (+moral)", out1: "Disseram que você é frio por não aparecer. (−moral)" },
                opt2: { label: "🤷 Deixo pra depois", out0: "Ficou pendente. Passou.", out1: "Virou público que você nem respondeu. (−moral)" },
            },
            "provocacion": {
                texto: "No último jogo um rival te provocou o tempo todo. Você cruza com ele num evento.",
                opt0: { label: "👊 Encaro ele", out0: "Esclareceram de homem pra homem. (+moral)", out1: "Quase foi parar na porrada e saiu em todo lugar. (−moral)" },
                opt1: { label: "🤝 Ofereço a mão", out0: "Gesto esportivo, ficou bem na fita. (+moral)", out1: "Ele deixou sua mão estendida. Mesmo assim você ficou bem." },
                opt2: { label: "🧊 Ignoro", out0: "Quem se estressa perde. (+moral)", out1: "Ficou com a raiva engolida. (−moral)" },
            },
            "cumple": {
                texto: "Aniversário de um colega e tem pré-festa forte na quinta.",
                opt0: { label: "🍾 Vou com tudo", out0: "Festejou com moderação, fortaleceu o grupo. (+moral)", out1: "Se excedeu e jogou mal no fim de semana. (−moral)" },
                opt1: { label: "🥂 Cumprimento e saio cedo", out0: "Equilíbrio perfeito. (+moral)", out1: "Perdeu a melhor parte. Aff." },
                opt2: { label: "🎁 Mando um presente e não vou", out0: "Detalhista. Cumpriu.", out1: "Ele ficou magoado por você não aparecer. (−moral)" },
            },
            "mate_dt": {
                texto: "O técnico te chama pra um chá pra conversar sobre seu papel no time.",
                opt0: { label: "🧉 Sento e escuto", out0: "Te deu confiança e apoiou. (+moral)", out1: "Disse que você tá em dúvida. Baque. (−moral)" },
                opt1: { label: "🗣️ Falo o que penso", out0: "Respeitou sua sinceridade. (+moral)", out1: "Não gostou nada do que você disse. (−moral)" },
                opt2: { label: "🙄 Vou por obrigação", out0: "Percebeu que você tava por fora. (−moral)", out1: "Conversaram sobre qualquer coisa." },
            },
            "apuesta": {
                texto: "Um \"amigo\" te oferece dinheiro pra \"pegar leve\" num jogo.",
                opt0: { label: "🚪 Boto ele pra fora na hora", out0: "Integridade total. (+moral)", out1: "Fez a coisa certa, mesmo ficando incomodado. (+moral)" },
                opt1: { label: "🤫 Digo que vou pensar", out0: "Ficou exposto a uma enrascada. (−moral)", out1: "Cortou antes que virasse um problema maior." },
                opt2: { label: "🚨 Denuncio pro clube", out0: "Jogou limpo e se protegeu. (+moral)", out1: "O cara começou a te ameaçar. (−moral)" },
            },
            "cabala": {
                texto: "Você tá invicto e a superstição é não lavar as meias da sorte.",
                opt0: { label: "🤢 Continuo usando", out0: "A sequência continua. (+moral)", out1: "Acabou de qualquer jeito e você fede horrível. (−moral)" },
                opt1: { label: "🌬️ Areio mas não lavo", out0: "Compromisso com a superstição. (+moral leve)", out1: "Não fez diferença nenhuma." },
                opt2: { label: "🧼 Lavo, sou adulto", out0: "Higiene em primeiro lugar. (+moral leve)", out1: "Justo perdeu e todo mundo te culpou. (−moral)" },
            },
            "utilero": {
                texto: "O roupeiro do clube tá passando por um momento pessoal difícil.",
                opt0: { label: "🤗 Dou uma força grande", out0: "O pessoal do clube te ama cada dia mais. (+moral)", out1: "Gesto nobre, mesmo meio estranho. (+moral)" },
                opt1: { label: "👂 Escuto um pouco", out0: "Fez bem pra ele desabafar. (+moral)", out1: "Conversaram e cada um seguiu." },
                opt2: { label: "😶 Não é problema meu", out0: "Frieza, notaram no clube. (−moral)", out1: "Outro assumiu." },
            },
            "influencer": {
                texto: "Um influencer te oferece seguidores por um desafio ridículo.",
                opt0: { label: "📲 Faço, não me importo", out0: "Viralizou, você entrou na brincadeira. (+moral)", out1: "Ficou constrangedor e te zoaram. (−moral)" },
                opt1: { label: "🎬 Faço do meu jeito", out0: "Deu sua marca própria e agradou. (+moral)", out1: "Passou sem pena nem glória." },
                opt2: { label: "🙅 Nem morto", out0: "Dignidade intacta. (+moral leve)", out1: "Quem fez ganhou um milhão de seguidores. (−moral)" },
            },
            "pelota_hattrick": {
                texto: "No último jogo você fez um hat-trick e ficou com a bola.",
                opt0: { label: "🖊️ Assino e penduro em casa", out0: "Lembrança eterna. (+moral)", out1: "Junta poeira numa prateleira." },
                opt1: { label: "🎁 Leilão pra uma causa", out0: "Arrecadou muito pras crianças. (+moral)", out1: "Ninguém ofereceu muito, meio vexame. (−moral)" },
                opt2: { label: "⚽ Uso pra treinar", out0: "Bola com história, você dedica horas nela. (+moral leve)", out1: "Furou na semana seguinte. Aff." },
            },
            "capitan_fecha": {
                texto: "O técnico te oferece a braçadeira de capitão por uma rodada.",
                opt0: { label: "💪 Pego e dou tudo", out0: "Liderança total, te respeitam. (+moral)", out1: "Quis motivar e ninguém deu bola. (−moral)" },
                opt1: { label: "🤝 Aceito sem exagerar", out0: "Liderou com o exemplo. (+moral)", out1: "Rodada tranquila, cumpriu." },
                opt2: { label: "😰 Não aguento, passo", out0: "Mostrou insegurança. (−moral)", out1: "O técnico entendeu que não era sua hora." },
            },
            "barra": {
                texto: "Um grupo de torcida organizada te chama pra \"uma reunião\" na sede.",
                opt0: { label: "🤝 Vou e faço amizade", out0: "Má companhia, ficou grudado numa confusão. (−moral)", out1: "Percebeu a tempo e se afastou. (−moral)" },
                opt1: { label: "📵 Não atendo", out0: "Melhor longe disso.", out1: "Se ofenderam e agora têm bronca de você. (−moral)" },
                opt2: { label: "🛡️ Aviso o clube", out0: "Jogou limpo, a diretoria te apoiou. (+moral)", out1: "A torcida organizada soube e te marcou. (−moral)" },
            },
            "documental": {
                texto: "Uma produtora quer fazer um documentário sobre sua vida.",
                opt0: { label: "🎥 Aceito e mostro TUDO", out0: "Ficou épico e humano. (+moral)", out1: "Mostrou demais e ficou exposto. (−moral)" },
                opt1: { label: "🎯 Só o lado futebolístico", out0: "Caprichado e profissional. (+moral)", out1: "Ficou chato e ninguém assistiu. (−moral)" },
                opt2: { label: "⏳ Deixo pra quando eu me aposentar", out0: "Decisão madura.", out1: "A produtora foi com outro." },
            },
            "penales_quiero": {
                texto: "O técnico tá decidindo quem vai bater os pênaltis do time.",
                opt0: { label: "🙋 Me ofereço", out0: "Ganhou o posto e a confiança. (+moral)", out1: "No treino errou 3 seguidos e foi descartado. (−moral)" },
                opt1: { label: "🎯 Digo que vou praticar e ver", out0: "Mostrou comprometimento. (+moral)", out1: "Ficou em segundo na lista. Normal." },
                opt2: { label: "🤐 Deixo outro bater", out0: "Não somou a pressão.", out1: "O escolhido tá errando, você pensa \"eu fazia\". (−moral)" },
            },
            "pibe_inferiores": {
                texto: "Um garoto das categorias de base pede conselhos pra estreia.",
                opt0: { label: "🧠 Sento e converso bastante", out0: "Virou referência pra ele. (+moral)", out1: "Deu uma força, mesmo ele não entendendo nada. (+moral)" },
                opt1: { label: "💬 Dou umas dicas rápidas", out0: "Conselho curto mas útil. (+moral)", out1: "Mal escutou. Passou." },
                opt2: { label: "😒 \"Não tenho tempo, garoto\"", out0: "Tratou mal, carma feio. (−moral)", out1: "Você tava com pressa, ele entendeu." },
            },
            "seleccion_amistoso": {
                texto: "Você é convocado pra seleção de {pais} pra um amistoso no meio da temporada.",
                opt0: { label: "🙌 Vou com tudo, é um orgulho", out0: "Vestir a camisa de {pais} te encheu de energia. (+moral)", out1: "Voltou destruído da viagem e rendeu mal. (−moral)" },
                opt1: { label: "🤝 Vou mas peço pra me cuidar", out0: "Somou minutos sem se desgastar. (+moral)", out1: "Jogou pouquinho. De rotina." },
                opt2: { label: "🚫 Não vou, prefiro descansar", out0: "A imprensa de {pais} te crucificou. (−moral)", out1: "Descansou e voltou como novo. (+moral)" },
            },
            "resaca": {
                texto: "Você acorda de ressaca e tem treino duplo.",
                opt0: { label: "🤮 Vou como der", out0: "Vomitou no centro de treinamento. Vergonha histórica. (−moral)", out1: "Aguentou na base do sofrimento. (−moral)" },
                opt1: { label: "☕ Litros de café e aguentando", out0: "Escapou raspando. Ninguém percebeu.", out1: "Mesmo assim rendeu péssimo. (−moral)" },
                opt2: { label: "🤧 Aviso que tô \"gripado\"", out0: "Escapou, mas ficou com a culpa.", out1: "O médico te examinou e descobriu tudo. (−moral)" },
            },
            "mansion": {
                texto: "Você compra uma mansão e quer festa de inauguração.",
                opt0: { label: "🎊 Festona com 200 convidados", out0: "Lendária e sem consequências. (+moral)", out1: "Saiu do controle e virou notícia. (−moral)" },
                opt1: { label: "🤝 Churrasco com colegas", out0: "Uniu o grupo na casa nova. (+moral)", out1: "Queimou o churrasco na casa nova. Mau presságio." },
                opt2: { label: "🍽️ Jantar pequeno com a família", out0: "Tranquilo e caloroso. (+moral leve)", out1: "Inauguração sem clima." },
            },
            "insulto_calle": {
                texto: "Um torcedor rival te xinga no supermercado na frente de todo mundo.",
                opt0: { label: "🤬 Respondo aos gritos", out0: "Quase foi parar na briga, te filmaram. (−moral)", out1: "Colocou ele no lugar e aplaudiram. (+moral)" },
                opt1: { label: "😏 Assino um autógrafo pra ele", out0: "Desarmou com classe. (+moral)", out1: "Ele jogou de volta na sua cabeça. (−moral)" },
                opt2: { label: "🛒 Continuo comprando", out0: "Nem olhou pra ele. Frieza. (+moral leve)", out1: "Ele te seguiu até o caixa. Constrangedor." },
            },
            "renovacion_charla": {
                texto: "O clube te oferece renovar por menos dinheiro do que você esperava.",
                opt0: { label: "😤 Peço o dobro ou vou embora", out0: "A relação com a diretoria azedou. (−moral)", out1: "Te deram. Conseguiu o que queria! (+moral)" },
                opt1: { label: "🤝 Negocio um meio-termo", out0: "Acordo justo pros dois lados. (+moral)", out1: "A conversa ficou em aberto. Passou." },
                opt2: { label: "❤️ Assino, amo essa camisa", out0: "A torcida te idolatra. (+moral)", out1: "Depois soube que um pior ganhava mais. (−moral)" },
            },
            "festejo_lesion": {
                texto: "Você tá ensaiando uma comemoração acrobática pro próximo gol.",
                opt0: { label: "🤾 O mortal triplo com tudo", out0: "Ficou incrível, vai arrasar. (+moral)", out1: "Se machucou ENSAIANDO. Inacreditável. (−moral)" },
                opt1: { label: "🕺 Uma dancinha simples", out0: "Grudenta e sem risco. (+moral)", out1: "Meio brega, mas passa." },
                opt2: { label: "🤫 Dedico à minha família", out0: "Gesto emocionante preparado com amor. (+moral)", out1: "Decidiu improvisar no dia do gol." },
            },
            "sesion_fotos": {
                texto: "Sessão de fotos pra nova camisa do clube.",
                opt0: { label: "😎 Poses ridículas de propósito", out0: "O clube não achou graça. (−moral)", out1: "Virou meme e o pessoal te amou. (+moral)" },
                opt1: { label: "🤩 Ponho energia e carisma", out0: "As fotos bombaram nas redes. (+moral)", out1: "Saiu com os olhos fechados em todas." },
                opt2: { label: "📸 Cara de jogador sério", out0: "Correto e profissional.", out1: "Fotos batidas." },
            },
            "jingle": {
                texto: "Pedem pra você gravar um jingle pra propaganda do clube.",
                opt0: { label: "🎶 Canto mesmo desafinando", out0: "Saiu horrível e te zoaram. (−moral)", out1: "Tão ruim que virou hit irônico. (+moral)" },
                opt1: { label: "🎸 Coloco meu estilo", out0: "Virou hit do clube. (+moral)", out1: "Ninguém lembra. (−moral leve)" },
                opt2: { label: "🗣️ Falo, não canto", out0: "Se saiu decente.", out1: "Ficou sem graça. Passou." },
            },
            "bandera": {
                texto: "A torcida prepara uma bandeira gigante com sua cara.",
                opt0: { label: "😭 Me emociono e abraço", out0: "Imagem pra história do clube. (+moral)", out1: "Tropeçou e quase rasgou. Susto." },
                opt1: { label: "🙌 Cumprimento de longe", out0: "Gesto simples e caloroso. (+moral)", out1: "Não te viram direito. Aff." },
                opt2: { label: "😬 Digo que me incomoda", out0: "A torcida se ofendeu. (−moral)", out1: "Entenderam, você é tímido." },
            },
            "esquema_dt": {
                texto: "Você não concorda com o esquema tático do técnico.",
                opt0: { label: "🗯️ Discuto na frente de todo mundo", out0: "Deixou ele mal, foi pro banco. (−moral)", out1: "Você tinha razão e o time melhorou. (+moral)" },
                opt1: { label: "🚪 Falo com ele em particular", out0: "Conversa madura, passou a te considerar mais. (+moral)", out1: "Ele mandou você se calar. (−moral)" },
                opt2: { label: "🤐 Guardo pra mim", out0: "Segurou a língua. Continua igual.", out1: "A raiva jogou contra você. (−moral)" },
            },
            "mascota": {
                texto: "Um cachorro de rua fica no centro de treinamento com o elenco.",
                opt0: { label: "🦴 Adoto como mascote do time", out0: "Virou o novo amuleto, todo mundo feliz. (+moral)", out1: "Mordeu justo você. (−moral)" },
                opt1: { label: "🍖 Dou comida e vejo", out0: "Bom gesto, o elenco apoiou. (+moral)", out1: "Foi embora no dia seguinte. Passou." },
                opt2: { label: "🚷 Que tirem ele", out0: "Ficou de vilão. (−moral)", out1: "Você tinha alergia, entenderam." },
            },
            "fifa_noche": {
                texto: "Maratona de FIFA com os colegas até qualquer hora.",
                opt0: { label: "🌙 Até as 5 da manhã sem parar", out0: "Chegou morto no treino. (−moral)", out1: "Ganhou o torneio e a glória do vestiário. (+moral)" },
                opt1: { label: "🎮 Umas partidas e dormir", out0: "Se divertiu sem exagerar. (+moral)", out1: "Perdeu rápido e foi embora. Aff." },
                opt2: { label: "😴 Hoje descanso", out0: "Profissional como poucos. (+moral)", out1: "Perdeu uma noite épica." },
            },
            "cerveza_marca": {
                texto: "Uma cervejaria te oferece pra ser a imagem deles na pré-temporada.",
                opt0: { label: "🍻 Assino e vou nos eventos", out0: "Levou bem sem descuidar do físico. (+moral)", out1: "Tantos eventos te deixaram pesado. (−moral)" },
                opt1: { label: "📝 Assino mas sem eventos", out0: "Boa grana, zero problema. (+moral)", out1: "Só a publicidade. Normal." },
                opt2: { label: "🚫 Não, tô na pré-temporada", out0: "Foco total. (+moral)", out1: "Perdeu um contratão, seu empresário furioso. (−moral)" },
            },
            "camiseta_partido": {
                texto: "Um garoto te escreve nas redes pedindo uma camisa autografada.",
                opt0: { label: "👕 Mando com dedicatória", out0: "História do ano, o garoto chorou de emoção. (+moral)", out1: "Gesto bonito, mesmo o correio perdendo por um mês. (+moral)" },
                opt1: { label: "📸 Mando uma foto autografada", out0: "Gesto simples mas ele valorizou. (+moral leve)", out1: "Queria a camisa, ficou meio chateado." },
                opt2: { label: "😶 Não tenho tempo pra isso", out0: "A mensagem viralizou, não ficou legal. (−moral)", out1: "Tava correndo, nem viu." },
            },
            "avion_demora": {
                texto: "O avião atrasa 6 horas e todo mundo tá de mau humor.",
                opt0: { label: "🃏 Proponho um joguinho de cartas", out0: "Uniu o grupo na espera. (+moral)", out1: "Ninguém quis jogar, ficou sozinho. (−moral)" },
                opt1: { label: "🎧 Coloco o fone de ouvido", out0: "Aguentou no seu próprio mundo.", out1: "A espera passou, nem percebeu." },
                opt2: { label: "😡 Reclamo aos gritos", out0: "Contagiou o clima ruim. (−moral)", out1: "Sua reclamação funcionou e trocaram nosso voo. (+moral)" },
            },
            "ingles": {
                texto: "Te oferecem um curso de inglês pensando na sua projeção internacional.",
                opt0: { label: "🎯 Vou com tudo", out0: "Cabeça focada em crescer. (+moral)", out1: "Não entendeu nada e ficou frustrado. (−moral)" },
                opt1: { label: "📖 Vou de vez em quando", out0: "Alguma coisa é melhor que nada.", out1: "Avança devagar mas com segurança." },
                opt2: { label: "😴 Que preguiça, largo", out0: "Zero vontade de progredir. (−moral)", out1: "No fim dá pra se virar com gestos. Aff." },
            },
            "penal_superclasico": {
                texto: "Vem aí o clássico. O técnico pergunta quem topa bater se rolar um pênalti.",
                opt0: { label: "🎯 Me ofereço, dou conta", out0: "O técnico te escolheu, se sente imbatível. (+moral)", out1: "Se ofereceu mas ele escolheu outro. Exposto. (−moral)" },
                opt1: { label: "🤔 Se ninguém quiser, eu bato", out0: "Mostrou personalidade sem forçar. (+moral)", out1: "Outro se ofereceu antes. Passou." },
                opt2: { label: "🙈 Que batam os mais experientes", out0: "Mostrou que a pressão pesa. (−moral)", out1: "Decisão sensata, o técnico valorizou. (+moral)" },
            },
            "comentarista": {
                texto: "Te convidam pra ser comentarista por um dia.",
                opt0: { label: "🗣️ Critico todo mundo", out0: "Fez inimigos nos dois vestiários. (−moral)", out1: "Afiado e picante, o público te amou. (+moral)" },
                opt1: { label: "😄 Coloco bom humor", out0: "Pediram pra você ser comentarista fixo. (+moral)", out1: "Travou e ficou mudo ao vivo. (−moral)" },
                opt2: { label: "🎙️ Comento neutro", out0: "Correto, sem polêmica.", out1: "Chato mas correto." },
            },
            "tatuador_amuleto": {
                texto: "Um vidente te oferece um amuleto \"pra nunca mais errar um gol\".",
                opt0: { label: "💸 Pago uma fortuna", out0: "Era um golpista, levou sua grana. (−moral)", out1: "Coincidência ou não, fez 3 gols seguidos. (+moral)" },
                opt1: { label: "🪙 Dou uma moeda por precaução", out0: "Por via das dúvidas, não perde nada. (+moral leve)", out1: "O amuleto não fez nada. Óbvio." },
                opt2: { label: "😂 Dou risada na cara dele", out0: "A situação te divertiu. (+moral)", out1: "Ele te lançou uma praga e na semana seguinte errou fácil. (−moral)" },
            },
            "balon_oro_gala": {
                texto: "Te convidam pra gala da Bola de Ouro, mesmo sabendo que não ganha esse ano.",
                opt0: { label: "🎩 Vou com toda energia", out0: "Aproveitou a noite entre os melhores do mundo. (+moral)", out1: "Ficou entediado esperando 3 horas à toa. (−moral)" },
                opt1: { label: "📱 Vou, tiro fotos e saio cedo", out0: "Cumpriu o compromisso sem desgaste. (+moral)", out1: "Ninguém percebeu que você saiu antes." },
                opt2: { label: "🙅 Prefiro não ir", out0: "Descansou tranquilo em casa.", out1: "Seu empresário ficou bravo pelo não comparecimento. (−moral)" },
            },
            "polemica_redes": {
                texto: "Você publica uma opinião polêmica sobre o nível da liga e vira confusão nas redes.",
                opt0: { label: "🔥 Mantenho o que disse", out0: "Bancou sua palavra, te respeitaram. (+moral)", out1: "Virou um escândalo midiático enorme. (−moral)" },
                opt1: { label: "😅 Explico que era brincadeira", out0: "Baixou a tensão com humor. (+moral leve)", out1: "Ninguém acreditou. (−moral)" },
                opt2: { label: "🗑️ Apago o post", out0: "Foi esquecido rápido.", out1: "Já tinham printado. Vexame. (−moral)" },
            },
            "nostalgia_lejos": {
                texto: "Faz meses que você tá longe do seu país e a saudade tá pesando.",
                opt0: { label: "📞 Videochamada longa com a família", out0: "Recarregou totalmente as energias. (+moral)", out1: "A conexão caía o tempo todo." },
                opt1: { label: "✈️ Tiro uns dias e viajo pra vê-los", out0: "Voltou renovado e com a cabeça no lugar. (+moral)", out1: "A viagem relâmpago te deixou mais cansado. (−moral)" },
                opt2: { label: "💪 Aguento e sigo focado", out0: "Profissional até o fim. (+moral leve)", out1: "A solidão começou a pesar de verdade. (−moral)" },
            },
            "nutricionista_estricto": {
                texto: "O nutricionista do clube propõe um plano alimentar bem rígido.",
                opt0: { label: "🥗 Sigo à risca", out0: "Se sente muito mais leve em campo. (+moral)", out1: "Sente falta da comida de sempre. (−moral)" },
                opt1: { label: "🍝 Adapto do meu jeito", out0: "Encontrou um equilíbrio que funciona. (+moral)", out1: "Nem fez diferença, continua igual." },
                opt2: { label: "🍕 Continuo comendo o de sempre", out0: "Pelo menos tá confortável.", out1: "A comissão técnica te chamou atenção. (−moral)" },
            },
            "amistad_rival": {
                texto: "Você ficou muito amigo de uma estrela de um time rival e a imprensa critica.",
                opt0: { label: "📸 Mostramos do mesmo jeito nas redes", out0: "O público valorizou o espírito esportivo. (+moral)", out1: "Uma parte da torcida reclamou muito. (−moral)" },
                opt1: { label: "🤫 Mantemos em privado", out0: "Cuidou da amizade sem alarde. (+moral)", out1: "Mesmo assim vazou uma foto." },
                opt2: { label: "🚪 Diminuo o contato com essa amizade", out0: "Menos confusão na mídia.", out1: "Doeu se afastar de alguém que você gosta. (−moral)" },
            },
            "catastrofe_solidaria": {
                texto: "Um desastre natural atingiu forte uma região e o clube organiza uma ajuda solidária.",
                opt0: { label: "❤️ Doo uma parte grande do meu salário", out0: "Seu gesto viralizou pelos motivos certos. (+moral)", out1: "Ajudou de verdade, mesmo que quase ninguém soubesse. (+moral)" },
                opt1: { label: "🤝 Participo do jogo/evento solidário", out0: "Somou presença e visibilidade à causa. (+moral)", out1: "Cumpriu o básico." },
                opt2: { label: "🤷 Prefiro não me envolver", out0: "Sua ausência foi notada e ficou mal. (−moral)", out1: "Ninguém comentou depois." },
            },
        },
};

export default resources;
